import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { EventUtil } from "../../util/EventUtil";
import { PageContext } from "../../service/PageContext";

export class MasonryReflow extends Component {

    public readonly MasonryReflowInitEvent:
  string = "MasonryReflowInitEvent";

  private reflowTimer : any

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.reflowTimer = undefined

    }

    public async init(): Promise<void> {
        $(() => {
            this.forceMasonryReflow(10000, 1000);
        });

        if(typeof(window.ReflowMasonry) !== 'function'){
            window.ReflowMasonry = this.reflowMasonry
            this._element.dispatchEvent(
                EventUtil.createCustomEvent(this.MasonryReflowInitEvent, "")
              );
        }
    }

    private reflowMasonry() : void {
        console.log("Masonry: Reflow requested.");
        if (!$('.card--layout').data('masonry')) {
          console.log("Masonry: Masonry not initialized.");
          return;
        }
        if(this.reflowTimer){
            clearTimeout(this.reflowTimer);
        }

        this.reflowTimer = setTimeout(function () {
          console.log("Masonry: Reflow executed!");
          try {
            $('.card--layout').masonry('layout');
          } catch (err) {
            //ignore error, likely masonry is not done loading
          };

        }, 50);
      }

      private forceMasonryReflow(duration :any, interval :any) : void {
        var counter = 0;
        var reflow = setInterval(function () {
          console.log("Masonry: Forcing reflow...");

          try {
            if ($('.card--layout').data('masonry')) {
              $('.card--layout').masonry('layout');
            }
          } catch (err) {
            //ignore error, likely masonry is not done loading
          };

          counter += interval;
          if (counter === duration) {
            clearInterval(reflow);
          }
        }, interval);
      }

}

ComponentFactory.registerComponent("MasonryReflow", MasonryReflow);
